import RestUtilities from './Base';

export default class Features {
  static async fetchFeatures() {
    const response = await RestUtilities.get(`/api/feature/list`);
      return response;
  }
}
